module.exports = __webpack_public_path__ + "img/aboutOurBackground.2036d2ed.png";